export default __webpack_public_path__ + "static/media/compras.c3ad0270.svg";